import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import MONTHS from '../../shared/months.js';
import FormatDollarAmount from './FormatDollarAmount.jsx';
import TieredCell from './TieredCell.jsx';

function MonthlyNetSalesRow({ netSale }) {
  return (
    <TableRow>
      <TableCell data-cy={`monthly-net-sales-category-${netSale.category}`}>
        {netSale.category}
      </TableCell>
      {MONTHS.map((month) => (
        <TieredCell
          key={month}
          month={month}
          data={netSale}
          data-cy={`monthly-net-sales-${month}-${netSale.category}`}
        />
      ))}
      <TableCell data-cy={`monthly-net-sales-total-${netSale.category}`}>
        <FormatDollarAmount amount={netSale.total} />
      </TableCell>
    </TableRow>
  );
}

MonthlyNetSalesRow.propTypes = {
  netSale: PropTypes.shape({
    category: PropTypes.string,
    tier1: PropTypes.number,
    tier2: PropTypes.number,
    tier2Start: PropTypes.number,
    tier3Start: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
};
export default React.memo(MonthlyNetSalesRow);
